import type { ProcessingJob } from "features/dt-plus-setup/model/types";

import { useEffect } from "react";

import { useJobLogFileContent } from "./useJobLogFileContent";
import { useJobLogFileUrl } from "./useJobLogFileUrl";
import { useJobLogStream } from "./useJobLogStream";

export const useJobLogs = (
  job: null | ProcessingJob | undefined,
  enabled: boolean,
  configId?: number,
  shouldRefresh = true
) => {
  const stream = useJobLogStream(job, enabled && shouldRefresh);
  const listing = useJobLogFileUrl(configId);
  const needsFile = enabled && (!shouldRefresh || (!stream.isStreaming && stream.lines.length === 0));
  const fileLogs = useJobLogFileContent(listing.file?.path, needsFile, shouldRefresh);
  const isLoadingFile = needsFile && fileLogs.isLoading;
  const lines = stream.lines.length > 0 ? stream.lines : fileLogs.lines;
  const isStreaming = stream.isStreaming || isLoadingFile;
  const error = lines.length > 0 || isStreaming ? null : fileLogs.error ?? stream.error;

  useEffect(() => {
    stream.bottomRef.current?.scrollIntoView({ block: "end" });
  }, [isStreaming, lines, stream.bottomRef]);

  return { bottomRef: stream.bottomRef, error, isStreaming, lines };
};
